import { OpenFeature } from '@openfeature/web-sdk'
import debug from '../console'
import type { UserEngagementStateUpdate } from '../../store/userData/UserEngagementStore'

const logger = debug.withTag('updateUserEngagementTracking')

export const updateUserEngagementTracking = (
  state: UserEngagementStateUpdate
) => {
  const {
    isEngaged,
    daysSinceInstall,
    lastEngagementAction,
    daysSinceLastEngagement,
    installDate,
  } = state

  logger.info(`User engagement state updated: isEngaged: ${isEngaged}`)

  OpenFeature.setContext({
    ...OpenFeature.getContext(),
    isEngaged,
    daysSinceInstall,
    installDate,
  })

  window.assertiveQueue = window.assertiveQueue || []
  window.assertiveQueue.push(function () {
    if (window.assertive?.analytics?.custom) {
      window.assertive.analytics.custom.userState = isEngaged
        ? 'isEngaged'
        : 'notEngaged'
      if (daysSinceInstall !== null) {
        window.assertive.analytics.custom.custom_12 = daysSinceInstall
      }
      if (lastEngagementAction !== null) {
        window.assertive.analytics.custom.custom_10 = lastEngagementAction
      }
      if (daysSinceLastEngagement !== null) {
        window.assertive.analytics.custom.custom_11 = daysSinceLastEngagement
      }
    }
  })

  window.googletag = window.googletag || { cmd: [] }
  window.googletag.cmd.push(() => {
    const targeting: Record<string, string> = {
      user_engagement: isEngaged ? 'isEngaged' : 'notEngaged',
    }
    if (daysSinceInstall !== null) {
      targeting.days_since_install = String(daysSinceInstall)
    }
    if (lastEngagementAction !== null) {
      targeting.engagement_action = lastEngagementAction
    }
    if (daysSinceLastEngagement !== null) {
      targeting.days_since_engagement = String(daysSinceLastEngagement)
    }
    window.googletag.setConfig({ targeting })
  })
}
